<div class="max-w-screen-sm mx-auto">
  @if (shop$ | async; as shop) {
    <app-simple-small-hero-atom
      [heading]="shop[shopKeys.Name]"
      [category]="shop[shopKeys.ShortDescription]"
      [description]="shop[shopKeys.Description]"
    ></app-simple-small-hero-atom>
  } @else {
    <div class="animate-pulse bg-neutral-200 h-40 w-full"></div>
  }
</div>
